import React from "react";

import "./Socials.scss";

const Socials = (props) => {
  const hostURL = window.location.host;
  const pathURL = window.location.pathname;

  return (
    <div className="Socials">
      <div className="Socials__text">Share</div>
      <a
        rel="noreferrer"
        target="_blank"
        href={`mailto:?subject=CX%20data%20assessment%20results&body=I%20took%20a%20quick%20assessment%20at%20%5Bhttps://${hostURL}${pathURL}%5D.%20Give%20it%20a%20try%20and%20share%20your%20results.`}
        className="Socials__icon Socials__icon--1"
      ></a>
      <a
        rel="noreferrer"
        href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${hostURL}${pathURL}`}
        className="Socials__icon Socials__icon--4"
        target="_blank"
      ></a>
      <a
        rel="noreferrer"
        href={`https://twitter.com/intent/tweet?url=https://${hostURL}${pathURL}&text=Take%20this%20#CXCommerce%20assessment%20to%20find%20out%20where%20you%20rank%20in%20commerce%20solutions.%20Find%20by%20the%20assessment%20here:`}
        className="Socials__icon Socials__icon--3"
        target="_blank"
      ></a>
      <a
        rel="noreferrer"
        href={`https://www.facebook.com/sharer/sharer.php?u=https://${hostURL}${pathURL}`}
        target="_blank"
        className="Socials__icon Socials__icon--2"
      ></a>
    </div>
  );
};

export default Socials;
